import React from 'react';
import type { ClaimStatus } from '../../../services/arsClaimService';

const STATUS_CONFIG: Record<ClaimStatus, { label: string; className: string }> = {
    draft: { label: 'Borrador', className: 'badge bg-secondary' },
    submitted: { label: 'Enviado', className: 'badge bg-info' },
    accepted: { label: 'Aceptado', className: 'badge bg-success' },
    partially_accepted: { label: 'Parcial', className: 'badge bg-warning text-dark' },
    rejected: { label: 'Rechazado', className: 'badge bg-danger' },
    cancelled: { label: 'Cancelado', className: 'badge bg-secondary' },
};

interface Props {
    status: ClaimStatus;
}

const ClaimStatusBadge: React.FC<Props> = ({ status }) => {
    const config = STATUS_CONFIG[status] ?? { label: status, className: 'badge bg-secondary' };
    return <span className={config.className}>{config.label}</span>;
};

export default ClaimStatusBadge;
